var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 0.333984C3.32671 0.333984 0.333374 3.32732 0.333374 7.00065C0.333374 10.674 3.32671 13.6673 7.00004 13.6673C10.6734 13.6673 13.6667 10.674 13.6667 7.00065C13.6667 3.32732 10.6734 0.333984 7.00004 0.333984ZM9.24004 8.53399C9.43337 8.72732 9.43337 9.04732 9.24004 9.24065C9.14004 9.34065 9.01337 9.38732 8.88671 9.38732C8.76004 9.38732 8.63337 9.34065 8.53337 9.24065L7.00004 7.70732L5.46671 9.24065C5.36671 9.34065 5.24004 9.38732 5.11337 9.38732C4.98671 9.38732 4.86004 9.34065 4.76004 9.24065C4.56671 9.04732 4.56671 8.72732 4.76004 8.53399L6.29337 7.00065L4.76004 5.46732C4.56671 5.27398 4.56671 4.95398 4.76004 4.76065C4.95337 4.56732 5.27337 4.56732 5.46671 4.76065L7.00004 6.29398L8.53337 4.76065C8.72671 4.56732 9.04671 4.56732 9.24004 4.76065C9.43337 4.95398 9.43337 5.27398 9.24004 5.46732L7.70671 7.00065L9.24004 8.53399Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/close-1.c96b9f16ab282e3f16831b8fb2540a16.svg";
export { ForwardRef as ReactComponent };